import type { SpellingBeeState } from "app/spelling-bee/spellingBeeState";
import {
  INITIAL_STATE,
  SpellingBeeAction,
  spellingBeeReducer,
} from "app/spelling-bee/spellingBeeState";
import useResetableStorage, {
} from "app/utils/useResetableStorage";
import { createContext, useCallback, useContext, useReducer } from "react";

export function useSpellingBeeReducer(storageKey: string) {
  const serializer = (state: SpellingBeeState): string => JSON.stringify(state);
  const deserializer = (value: string): SpellingBeeState => JSON.parse(value);

  const [savedState, setSaveState] = useResetableStorage(
    storageKey,
    INITIAL_STATE,
    { raw: false, serializer, deserializer },
  );

  const reducerLocalStorage = useCallback(
    (state: SpellingBeeState, action: SpellingBeeAction) => {
      const newState = spellingBeeReducer(state, action);
      setSaveState(newState);
      return newState;
    },
    [setSaveState],
  );

  return useReducer(reducerLocalStorage, savedState || INITIAL_STATE);
}

export const SpellingBeeDispatchContext = createContext<
  React.Dispatch<SpellingBeeAction>
>(() => {});

export function useSpellingBeeActionDispatch() {
  return useContext(SpellingBeeDispatchContext);
}

export const SpellingBeeContext =
  createContext<SpellingBeeState>(INITIAL_STATE);

export function useSpellingBeeState() {
  return useContext(SpellingBeeContext);
}
